export default "__VITE_ASSET__BINvOwL$__"